import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUnitUsers,
  updateUnitUsers,
  getUnitsUsers,
} from "src/slices/UnitsUsers/thunk";
import { useNavigate } from "react-router-dom";

const ModalValidation = ({
  selectedUnit,
  setModal,
  setSuccessDelete,
  setErrorDelete,
  setSuccessUpdate,
  setErrorUpdate,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const units = useSelector((state: any) => state.units.units);
  const validation = useFormik({
    initialValues: {
      user_id: `${selectedUnit.user_id}`,
      unit_id: `${selectedUnit.unit_id}`,
      level: `${selectedUnit.level}`,
    },
    validationSchema: Yup.object({
      user_id: Yup.string().required("Por favor, insira o utilizador"),
      unit_id: Yup.string().required("Por favor, insira o orgão de estrutura"),
      level: Yup.string().required("Por favor, insira o nível"),
    }),

    onSubmit: values => {
      dispatch(updateUnitUsers({ ...values, id: selectedUnit.id })).then(
        response => {
          setModal(false);
          if (
            typeof response.payload === "string" &&
            response.payload.includes("Request failed with")
          ) {
            setErrorUpdate(true);
          } else {
            setSuccessUpdate(true);
          }
        }
      );
      if (selectedUnit.urlParam) {
        navigate(`/users/${selectedUnit.user_id}`);
      }
    },
  });
  const handleDelete = () => {
    dispatch(deleteUnitUsers(selectedUnit.id)).then(response => {
      setModal(false);
      if (
        typeof response.payload === "string" &&
        response.payload.includes("Request failed with")
      ) {
        setErrorDelete(true);
      } else {
        setSuccessDelete(true);
        dispatch(getUnitsUsers());
      }
    });
  };

  return (
    <React.Fragment>
      <Form
        className="needs-validation"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom04">Orgão de Estrutura</Label>
            <Input
              name="unit_id"
              placeholder="Insira o nome do orgão de estrutura"
              type="select"
              className="form-control"
              id="validationCustom04"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.unit_id || ""}
              invalid={
                validation.touched.unit_id && validation.errors.unit_id
                  ? true
                  : false
              }
            >
              <option value="">Selecione</option>
              {units.map((unit: any) => (
                <option value={unit.id} key={unit.id}>
                  {unit.name}
                </option>
              ))}
            </Input>
            {validation.touched.unit_id &&
            typeof validation.errors.unit_id === "string" ? (
              <FormFeedback type="invalid">
                {validation.errors.unit_id}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom03">Nivel</Label>
            <Input
              name="level"
              placeholder="Nivel"
              type="select"
              className="form-control"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.level || ""}
              invalid={
                validation.touched.level && validation.errors.level
                  ? true
                  : false
              }
            >
              <option value="">Selecione</option>
              <option value="1">Nivel 1</option>
              <option value="2">Nivel 2</option>
              <option value="3">Nivel 3</option>
              <option value="4">Nivel 4</option>
              <option value="5">Nivel 5</option>
              <option value="6">Nivel 6</option>
            </Input>
            {validation.touched.level &&
            typeof validation.errors.level === "string" ? (
              <FormFeedback type="invalid">
                {validation.errors.level}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>

        <div className="d-flex flex-wrap gap-2">
          <Button color="primary" type="submit">
            Submiter
          </Button>
          <Button type="button" color="danger" onClick={handleDelete}>
            Apagar
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default ModalValidation;
